import React from 'react';
import { brandColors } from '../../config/theme';

const BulkActions = ({ 
  selectedCount, 
  totalCount, 
  onSelectAll, 
  onBulkAction,
  isLoading,
  isAllSelected 
}) => {
  const handleAction = (action) => {
    if (action === 'reject' || action === 'delete') {
      const reason = prompt(
        `Please provide a reason for ${action}:`,
        action === 'reject' ? 'Does not meet marketplace guidelines' : 'Violation of marketplace policies'
      );
      if (reason !== null) {
        onBulkAction(action, reason);
      }
    } else {
      if (window.confirm(`Are you sure you want to ${action} ${selectedCount} listing(s)?`)) {
        onBulkAction(action);
      }
    }
  };
  
  const actions = [
    { id: 'approve', label: 'Approve', icon: '✅', color: brandColors.accent },
    { id: 'reject', label: 'Reject', icon: '❌', color: brandColors.danger },
    { id: 'feature', label: 'Feature', icon: '⭐', color: brandColors.secondary },
    { id: 'unfeature', label: 'Unfeature', icon: '⭐', color: brandColors.gray },
    { id: 'delete', label: 'Delete', icon: '🗑️', color: brandColors.danger },
  ];
  
  return (
    <div className="bg-white rounded-xl shadow-lg border-2 border-orange-200 p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center bg-orange-100">
              <span className="text-orange-600 font-bold">{selectedCount}</span>
            </div>
            <div>
              <h3 className="font-bold text-gray-900">Bulk Actions</h3>
              <p className="text-sm text-gray-600">
                {selectedCount} of {totalCount} listings selected
              </p>
            </div>
          </div>
          
          <button
            onClick={onSelectAll}
            className="px-4 py-2 rounded-lg text-sm font-medium border transition-colors hover:shadow-sm flex items-center gap-2"
            style={{ 
              borderColor: brandColors.primary,
              color: brandColors.primary,
              backgroundColor: 'white'
            }}
          >
            <span>{isAllSelected ? '☐' : '☑'}</span>
            <span>{isAllSelected ? 'Deselect All' : 'Select All'}</span>
          </button>
        </div>
        
        <div className="flex flex-wrap gap-2">
          {actions.map((action) => (
            <button
              key={action.id}
              onClick={() => handleAction(action.id)}
              disabled={isLoading}
              className="px-4 py-2.5 rounded-lg text-sm font-medium text-white transition-all duration-200 hover:shadow-md flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ backgroundColor: action.color }}
            >
              {isLoading ? (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              ) : (
                <>
                  <span>{action.icon}</span>
                  <span>{action.label}</span>
                </>
              )}
            </button>
          ))}
        </div>
      </div>
      
      {isLoading && (
        <div className="mt-4">
          <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
            <div 
              className="h-full rounded-full animate-pulse"
              style={{ 
                width: '100%',
                backgroundColor: brandColors.primary 
              }}
            ></div>
          </div>
          <p className="text-xs text-gray-500 mt-2 text-center">
            Processing {selectedCount} listings...
          </p>
        </div>
      )}
    </div>
  );
};

export default BulkActions;